<template>
  <v-dialog
    v-model="dialogValue"
    :max-width="maxWidth"
    content-class="media-viewer-dialog"
    scrollable
  >
    <v-card class="media-viewer-card my-5">
      <div
        v-if="kind === MEDIA_VIEWER_KINDS.IMAGE && src"
        class="media-viewer-image-wrapper"
      >
        <img
          :src="src"
          :alt="title"
          :title="title"
          class="secure-image media-viewer-media"
          @error="emit('error')"
        >
        <!--
          画像保存抑止を目的とした右クリック対策のオーバーレイ。
        -->
        <div
          class="media-viewer-event-blocker"
          @contextmenu.prevent
          @selectstart.prevent
          @mousedown.prevent
          @dragstart.prevent
        />
      </div>
      <video
        v-if="kind === MEDIA_VIEWER_KINDS.VIDEO && src"
        :src="src"
        class="media-viewer-media"
        controls
        controlsList="nodownload"
        oncontextmenu="return false;"
        @error="emit('error')"
      />
      <v-btn
        position="absolute"
        class="icon-button"
        color="gray-lighten-4"
        fab
        size="x-small"
        @click="dialogValue = false"
      >
        ×
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { MEDIA_VIEWER_KINDS, type MediaViewerKind } from "../model/mediaViewerController";

type Props = {
  modelValue: boolean;
  src?: string;
  title?: string;
  kind?: MediaViewerKind;
  maxWidth?: string;
};

const props = withDefaults(defineProps<Props>(), {
  src: "",
  title: "",
  kind: MEDIA_VIEWER_KINDS.IMAGE,
  maxWidth: "60%",
});

const emit = defineEmits<{
  "update:modelValue": [boolean];
  error: [];
}>();

const dialogValue = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit("update:modelValue", val),
});

const src = computed(() => props.src);
const title = computed(() => props.title);
const kind = computed(() => props.kind);
const maxWidth = computed(() => props.maxWidth);
</script>

<style lang="scss" scoped>
.media-viewer-card {
  position: relative;
  max-height: calc(100vh - 40px);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
}

.media-viewer-image-wrapper {
  position: relative;
  display: inline-block;
  max-width: 100%;
  max-height: calc(100vh - 80px);
}

.media-viewer-media {
  display: block;
  width: auto;
  max-width: 100%;
  max-height: calc(100vh - 80px);
  object-fit: contain;
}

.media-viewer-event-blocker {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.icon-button {
  top: 0;
  right: 0;
  font-size: 18px;
}
</style>
